import React from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import { FormattedMessage } from 'react-intl';

import { textDetailsMessages } from './lineItemMessages';

const formatDate = dateString => format(new Date(dateString), 'LLLL d, y');

export const LineItemTextDetails = ({ deliveryMethod, isSelfBuy, senderName, recipientEmail, deliveryDate, message }) => (
    <div className="line-item-text-detail">
        {deliveryMethod !== 'PHYSICAL' ? (
                        <div>
                {!isSelfBuy && (
                    <React.Fragment>
                        <div>
                            <FormattedMessage {...textDetailsMessages.to} />
                            <b>{recipientEmail}</b>
                        </div>
                        <div>
                            <FormattedMessage {...textDetailsMessages.from} />
                            <b>{senderName}</b>
                        </div>
                        <div>
                            <FormattedMessage {...textDetailsMessages.deliveryDate} />
                            <b>{formatDate(deliveryDate)}</b>
                        </div>
                    </React.Fragment>
                )}
                {message && (
                    <div className="message">
                        <br />
                        {message}
                    </div>
                )}
            </div>
        ) : (
                        <div>
                {message && (
                    <div className="message">
                        <br />
                        {message}
                    </div>
                )}
            </div>
        )}
    </div>
);

LineItemTextDetails.defaultProps = {
    senderName: '',
    recipientEmail: '',
    deliveryDate: '',
    message: '',
};

LineItemTextDetails.propTypes = {
    deliveryMethod: PropTypes.string.isRequired,
    isSelfBuy: PropTypes.bool.isRequired,
    senderName: PropTypes.string,
    recipientEmail: PropTypes.string,
    deliveryDate: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(Date)
    ]),
    message: PropTypes.string,
};
